import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { provide } from 'alfa';
import mainStore from "./store";

const Root = provide(App, mainStore);

ReactDOM.render(<Root />, document.getElementById('root'));
